import React from "react"

function IconArrowsSortUp({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="arrows-sort-up"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-arrows-sort-up"
      {...props}
    >
      <path
        d="M17.01 15.3a.655.655 0 0 0-.834-1.002l-.09.076-3.806 3.805-3.805-3.805a.655.655 0 0 0-.835-.076l-.091.075a.655.655 0 0 0-.076.835l.076.091 4.267 4.269c.228.227.58.252.835.076l.091-.076 4.269-4.269z"
        opacity=".5"
      />
      <path d="M17.01 8.824a.655.655 0 0 1-.834 1.001l-.09-.075-3.806-3.806L8.475 9.75a.655.655 0 0 1-.835.076l-.091-.076a.655.655 0 0 1-.076-.835l.076-.09 4.267-4.27a.655.655 0 0 1 .835-.075l.091.075 4.269 4.27z" />
    </svg>
  )
}

export default IconArrowsSortUp
